const configuredSiteKey = (process.env.VUE_APP_RECAPTCHA_SITE_KEY || '').trim()
const configuredKeySlot = (process.env.VUE_APP_RECAPTCHA_KEY_SLOT || 'current')
  .trim()
  .toLowerCase()

const validKeySlots = ['current', 'next']

export const recaptchaSiteKey = configuredSiteKey
export const recaptchaKeySlot = configuredKeySlot
export const recaptchaConfigurationError = !configuredSiteKey
  ? 'Form verification is temporarily unavailable. Please try again later.'
  : !validKeySlots.includes(configuredKeySlot)
    ? 'Form verification configuration is invalid. Please try again later.'
    : ''
export const isRecaptchaConfigured = !recaptchaConfigurationError

export function appendRecaptchaKeySlot (formData: FormData): void {
  formData.append('rcaptcha_key_slot', recaptchaKeySlot)
}
